// #genai Phase 2 "Payment method already exists" dialog — pixel-matched to Figma 732:26114
// (desktop, 450px) and 732:26388 (mobile, 342px). Fired from BOTH AddAchPaymentMethod and
// AddCardPaymentMethod when a submit attempt returns a duplicate-payment-method error (see
// getSubmitErrorDialogKind in BankAccountInfoErrors.js). "Ok" dismisses (parent clears
// submitInfo); "Return to Payment Methods (Billing)" navigates back to the /billing-information
// list so the user can review already-saved methods.
import React from 'lib/react';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import {
  EVButton,
  EVDialog,
  EVDialogActions,
  EVDialogContent,
  EVDialogContentText,
  EVDialogTitle,
} from 'lib/components';
import SubmitErrorDialogsStyles from './SubmitErrorDialogsStyles';

function PaymentMethodExistsDialog({ open, onOk, onReturn }) {
  const { t } = useTranslation();
  const classes = SubmitErrorDialogsStyles();

  return (
    <EVDialog open={open} onClose={onOk} classes={{ paper: classes.dialog }}>
      <EVDialogTitle disableTypography className={classes.title}>
        {t('billing_information__pm_exists_title')}
      </EVDialogTitle>
      <EVDialogContent className={classes.content}>
        <EVDialogContentText className={classes.message}>
          {t('billing_information__pm_exists_message')}
        </EVDialogContentText>
      </EVDialogContent>
      <EVDialogActions className={classes.actions}>
        <EVButton
          id="pm-exists-return-btn"
          variant="text"
          className={classes.returnLinkButton}
          onClick={onReturn}
        >
          {t('billing_information__pm_exists_return')}
        </EVButton>
        <EVButton
          id="pm-exists-ok-btn"
          variant="contained"
          className={classes.okButton}
          onClick={onOk}
        >
          {t('billing_information__pm_dialog_ok')}
        </EVButton>
      </EVDialogActions>
    </EVDialog>
  );
}

PaymentMethodExistsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onReturn: PropTypes.func.isRequired,
};

export default PaymentMethodExistsDialog;
